module.exports = __webpack_public_path__ + "static/79af27ca9a3d9f96fcb8a7e240592bab55ffcd6112bfa6fd051e3af12c0a17d5-b4645d16158f0fbb8fb903c18ebfc1ae.jpeg";